
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { checkIfSectionTitleIsDeletable } from '../../../../utils/editor.util';

@Component({})
export default class SectionCard extends Vue {
  @Prop(String) public sectionId!: string;
  @Prop(String) public text!: string;
  @Prop(Boolean) public draggable!: boolean;

  public handleClick() {
    // scroll section into view
    const target = document.getElementById(this.sectionId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Allow deletion of non default section titles
  public checkIfDeletable() {
    return checkIfSectionTitleIsDeletable(this.text);
  }
}
